import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, ClipboardList, BookText, ArrowLeftRight, BarChart3, User,
  Printer, CalendarRange, CalendarDays, Download, Info, X, Stamp, LogOut
} from "lucide-react";
import RtSearch from "./RtSearch";

const menu = [
  { section: "Dashboard", items: [
    { to: "/", icon: LayoutDashboard, label: "Dashboard Utama" },
    { to: "/status", icon: ClipboardList, label: "Status Pelaporan" },
  ]},
  { section: "Kependudukan", items: [
    { to: "/a5", icon: BookText, label: "Buku Matriks A.5" },
    { to: "/mutasi", icon: ArrowLeftRight, label: "Mutasi Bulanan" },
    { to: "/rekap", icon: BarChart3, label: "Rekapitulasi RT/RW" },
    { to: "/detail", icon: User, label: "Detail RT" },
  ]},
  { section: "Laporan", items: [
    { to: "/cetak", icon: Printer, label: "Cetak A.5" },
    { to: "/rekap-bulanan", icon: CalendarRange, label: "Rekap Bulanan" },
    { to: "/rekap-tahunan", icon: CalendarDays, label: "Rekap Tahunan" },
    { to: "/ekspor", icon: Download, label: "Ekspor Data" },
  ]},
  { section: "Sistem", items: [
    { to: "/master-aset", icon: Stamp, label: "Master TTD & Stempel" },
    { to: "/tentang", icon: Info, label: "Tentang Sistem" },
  ]},
];

export default function Sidebar({ onClose, onLogout }) {
  return (
    <aside className="sidebar h-screen w-[260px] flex flex-col shrink-0" data-testid="sidebar">
      <div className="px-5 pt-6 pb-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="sidebar-brand-badge w-11 h-11 rounded-xl flex items-center justify-center text-white font-black text-lg">
            S
          </div>
          <div>
            <div className="text-white font-extrabold tracking-tight text-[1.05rem] leading-tight">SILAPDI</div>
            <div className="text-[0.68rem] text-[color:var(--sidebar-text-muted)] font-semibold tracking-wider">BUKU PENDUDUK A.5</div>
          </div>
        </div>
        {onClose && (
          <button onClick={onClose} className="lg:hidden text-white/70 hover:text-white" data-testid="sidebar-close">
            <X size={20} />
          </button>
        )}
      </div>
      <div className="px-3 py-2 mx-3 mb-3 rounded-lg bg-white/[0.04] border border-white/5">
        <div className="text-[0.72rem] text-[color:var(--sidebar-text-muted)]">Kelurahan</div>
        <div className="text-white text-sm font-semibold">Suka Asih</div>
        <div className="text-[0.7rem] text-[color:var(--sidebar-text-muted)]">Kota Bandung</div>
      </div>
      <RtSearch onNavigate={onClose} />
      <nav className="flex-1 overflow-y-auto px-3 pb-6">
        {menu.map((g) => (
          <div key={g.section}>
            <div className="sidebar-section-label">{g.section}</div>
            {g.items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                onClick={onClose}
                className={({ isActive }) => `sidebar-nav-item ${isActive ? "active" : ""}`}
                data-testid={`nav-${it.to.replace("/", "") || "home"}`}
              >
                <it.icon size={17} strokeWidth={2} />
                <span>{it.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div className="px-5 pb-5 text-[0.68rem] text-[color:var(--sidebar-text-muted)]">
        <button
          type="button"
          onClick={onLogout}
          className="mb-4 flex w-full items-center gap-2 rounded-lg px-2 py-2 text-sm font-semibold text-white/80 hover:bg-white/[0.06] hover:text-white"
          data-testid="logout-button"
        >
          <LogOut size={16} />
          Keluar
        </button>
        © 2026 Kelurahan Suka Asih
      </div>
    </aside>
  );
}
